module.exports = __webpack_public_path__ + "static/media/joao_pedro.c6df1d75.jpg";